import { GenCountyCoverage } from '../../generated/serverModels/GenCountyCoverage';

export class Coverage extends GenCountyCoverage {
  constructor(countyCoverage?:Coverage) {
    super(countyCoverage);
  }
}
